import withRoot from './modules/withRoot';
// --- Post bootstrap -----
import React from 'react';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
//import Markdown from './modules/components/Markdown';
import Typography from './modules/components/Typography';
import AppAppBar from './modules/views/AppAppBar';
//import terms from './modules/views/terms.md';
import AppFooter from './modules/views/AppFooter';

function Terms() {
  const [appLanguage, setAppLanguage] = React.useState("");
  return (
    <React.Fragment>
      <AppAppBar language={appLanguage} />
      <Container>
        <Box mt={7} mb={12}>
          <Typography variant="h3" gutterBottom marked="center" align="center">
            Terms
          </Typography>
          <iframe title="terms" src='/static/terms.md' width="100%"  height="1000"/>
        </Box>
      </Container>
      <AppFooter language={appLanguage} onLanguageChange={(event)=>{setAppLanguage(event.target.value)}}/>
    </React.Fragment>
  );
}

export default withRoot(Terms);